import { render, staticRenderFns } from "./modelTitle.vue?vue&type=template&id=568fe4b1&scoped=true"
import script from "./modelTitle.vue?vue&type=script&lang=js"
export * from "./modelTitle.vue?vue&type=script&lang=js"
import style0 from "./modelTitle.vue?vue&type=style&index=0&id=568fe4b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fe4b1",
  null
  
)

export default component.exports